type Props = {
  width?: string;
  height?: string;
  fillColor?: string;
};

const DropdownCaretIcon = ({ width = '12', height = '7', fillColor = 'white' }: Props) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 12 7"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.99994 6.21051L0.803788 0.0526161L11.1961 0.052617L5.99994 6.21051Z"
        fill={fillColor}
      />
    </svg>
  );
};

export default DropdownCaretIcon;
